import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery, maxWidth } from '../../theme/metrics'
import { WHITE_01 } from '../../theme/colors'

import { button } from '../../theme/core';

import { StyledLinks } from '../../theme/components'


export const Container = styled.section`
	padding-bottom: ${unit(8)};
	background-color: ${props => props.theme.background};

	${mediaQuery[SIZE.medium]}{
		padding-bottom: 0;
		margin-bottom: 0;
	}
`

export const ContainerInner = styled.div`
	${grid}
	margin: 0 auto;
	max-width: ${maxWidth()};
`

export const Inner = styled.div`
	${row({medium:true})}
`

export const ContentContainer = styled.div`
	${props => column({medium:{span:6}},{direction:props.theme.direction})}
	padding-top: ${unit(8)};
	padding-bottom: ${unit(8)};
	background-color: ${props => props.theme.background};

	margin-left: ${margin(SIZE.small, {multiplier:-1})};
	margin-right: ${margin(SIZE.small, {multiplier:-1})};
	padding-left: ${margin(SIZE.small)};
	padding-right: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-top: ${unit(8)};
		padding-bottom: ${unit(8)};
	}

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(2)};
		padding-bottom: ${spacer(3)};
	}
`

export const QuoteContent = styled.blockquote`
	&:before{
		content: url(/images/quote-yellow.svg);
		width:42px;
		height:29px;
		margin-bottom: ${unit(3)};
		display: block;
	}

	${mediaQuery[SIZE.medium]}{
		&:before{
			padding-bottom: ${spacer(1)};
		}
	}
`

export const QuoteText = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};

	em{
		background-color: ${props => props.theme.highlight};
	}
`

export const QuoteFooter = styled.footer`
	margin-top: ${unit(3)};
	display: flex;
	align-items: flex-start;

	&:before{
		content: "―";
		${typeLabel01}
		margin-right: ${unit(1)};
	}
`

export const Citation = styled.cite`
	${typeLabel01}
	color: ${props => props.theme.foreground};

	a{
		color: ${props => props.theme.foreground};
		text-decoration: none;
		transition: opacity 0.3s;

		&:hover{
			opacity: 0.6;
		}
	}
`

export const ImageContainer = styled.div`
	${props => column({medium:{span:6},large:{span:5,before:1}},{direction:props.theme.direction})}
	margin-top: ${unit(-16)};

	${mediaQuery[SIZE.medium]}{
		margin-top: 0;
	}
`

export const ImageInner = styled.div`
	flex: 1;
	position: relative;
	top: ${unit(16)};

	${mediaQuery[SIZE.medium]}{
		position: relative;
		height: 100%;
		top: ${unit(8)};
		overflow: hidden;
		position: relative;
	}

	${mediaQuery[SIZE.large]}{
		top: ${spacer(2)};
	}

`

export const Image = styled.img`
	width: 100%;
	height: auto;
	display: block;

	${mediaQuery[SIZE.medium]}{
		height: 100%;
		object-fit: cover;
		position: absolute;

		// IE 10,11 hack
		@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
			height: 100%;
			width: auto;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
		}
	}
`

export const Links = styled(StyledLinks)`
	padding-top: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		padding-top: ${spacer(2)};
	}
`